import './App.css';
import Main from "./pages/Main";
import {useEffect} from "react";
import { useSelector } from "react-redux";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { StyleProvider } from '@ant-design/cssinjs';
import { ConfigProvider } from 'antd';
import ruRU from 'antd/locale/ru_RU';
import kkKZ from 'antd/locale/kk_KZ';
import enUS from 'antd/locale/en_US';
import dayjs from 'dayjs';
import 'dayjs/locale/ru';
import 'dayjs/locale/kk';
import 'dayjs/locale/en';
import './utils/reset.css';
import ErrorBoundary from './components/ErrorBoundary';
import { dayjsLocaleCode, htmlLang } from './utils/locale';

const antdLocale = {
    nameRu: ruRU,
    nameKz: kkKZ,
    nameEn: enUS,
};

function App() {
    const lang = useSelector((state) => state.app.lang) || 'nameRu';
    const serviceName = useSelector((state) => state.app.serviceName);
    
    // Устанавливаем заголовок страницы
    useEffect(() => {
        document.title = serviceName?.[lang] || serviceName?.nameRu || 'Drone management';
        document.documentElement.lang = htmlLang(lang);
    }, [lang, serviceName]);

    // Настройка локали для dayjs в зависимости от выбранного языка
    useEffect(() => {
        dayjs.locale(dayjsLocaleCode(lang));
    }, [lang]);

    const router = createBrowserRouter(
        [{ path: "/*", element: <Main />, },],
        { future: { v7_startTransition: true, }, }
    );
    return (
        <ErrorBoundary>
            <StyleProvider hashPriority="high">
                <ConfigProvider locale={antdLocale[lang] || ruRU}>
                    <div className="App">
                        <RouterProvider router={router} future={{ v7_startTransition: true }} />
                    </div>
                </ConfigProvider>
            </StyleProvider>
        </ErrorBoundary>
    );
}

export default App;
